/**
 * Classic signature template.
 *
 * Layout: photo and info side-by-side, minimal styling, suitable for
 * conservative corporate environments.
 */
export function buildClassicTemplate(profile, prefs) {
    const p = mergeWithOverrides(profile, prefs);
    const textColor = "#000000";
    const mutedColor = "#555555";
    const linkColor = "#0563C1";
    const fontStack = "Arial, Helvetica, sans-serif";
    const fontSize = "12px";
    const lineHeight = "16px";
    const photoHtml = `
    <img
      src="${p.photoDataUri}"
      width="80"
      height="80"
      alt="${escapeHtml(p.displayName)}"
      border="0"
      style="display:block; width:80px; height:80px; object-fit:cover;"
    />`;
    const lines = [];
    lines.push(`<b style="font-family:${fontStack}; font-size:14px; color:${textColor};">${escapeHtml(p.displayName)}</b>`);
    if (p.jobTitle) {
        lines.push(`<span style="font-family:${fontStack}; font-size:${fontSize}; color:${textColor};">${escapeHtml(p.jobTitle)}</span>`);
    }
    const companyDept = [p.companyName, p.department].filter(Boolean).map(escapeHtml).join(" | ");
    if (companyDept) {
        lines.push(`<span style="font-family:${fontStack}; font-size:${fontSize}; color:${mutedColor};">${companyDept}</span>`);
    }
    lines.push(""); // blank line separator
    if (p.email) {
        lines.push(`<span style="font-family:${fontStack}; font-size:${fontSize}; color:${textColor};">E: <a href="mailto:${escapeHtml(p.email)}" style="color:${linkColor};">${escapeHtml(p.email)}</a></span>`);
    }
    if (p.directPhone) {
        lines.push(`<span style="font-family:${fontStack}; font-size:${fontSize}; color:${textColor};">T: ${escapeHtml(p.directPhone)}</span>`);
    }
    if (p.mobilePhone) {
        lines.push(`<span style="font-family:${fontStack}; font-size:${fontSize}; color:${textColor};">M: ${escapeHtml(p.mobilePhone)}</span>`);
    }
    const addressParts = [
        p.streetAddress,
        p.city,
        p.state,
        p.postalCode,
        p.country,
    ].filter(Boolean);
    if (addressParts.length > 0) {
        lines.push(`<span style="font-family:${fontStack}; font-size:${fontSize}; color:${mutedColor};">${addressParts.map(escapeHtml).join(", ")}</span>`);
    }
    if (prefs.websiteUrl) {
        lines.push(`<span style="font-family:${fontStack}; font-size:${fontSize};"><a href="${escapeAttr(prefs.websiteUrl)}" style="color:${linkColor};">${escapeHtml(prefs.websiteUrl)}</a></span>`);
    }
    if (prefs.linkedInUrl) {
        lines.push(`<span style="font-family:${fontStack}; font-size:${fontSize};"><a href="${escapeAttr(prefs.linkedInUrl)}" style="color:${linkColor};">LinkedIn</a></span>`);
    }
    const infoHtml = lines
        .map((line) => {
        if (!line)
            return `<tr><td style="padding-top:4px;">&nbsp;</td></tr>`;
        return `<tr><td style="padding-top:2px; line-height:${lineHeight};">${line}</td></tr>`;
    })
        .join("\n");
    return `
<table
  cellpadding="0"
  cellspacing="0"
  border="0"
  width="480"
  style="border-collapse:collapse; font-family:${fontStack};"
>
  <tr>
    <td style="padding-top:10px; padding-bottom:6px;" colspan="3">
      <hr style="border:0; border-top:1px solid #cccccc; margin:0; padding:0;" />
    </td>
  </tr>
  <tr>
    <!-- Photo -->
    <td valign="top" style="padding-right:12px; width:80px;">
      ${photoHtml}
    </td>
    <!-- Divider -->
    <td valign="top" style="padding-right:12px; width:1px; border-left:1px solid #cccccc;"></td>
    <!-- Info -->
    <td valign="top">
      <table cellpadding="0" cellspacing="0" border="0">
        ${infoHtml}
      </table>
    </td>
  </tr>
</table>
`.trim();
}
function mergeWithOverrides(profile, prefs) {
    return Object.assign(Object.assign({}, profile), prefs.overrides);
}
function escapeHtml(str) {
    return str
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
}
function escapeAttr(str) {
    const clean = str.replace(/^javascript:/i, "");
    return encodeURI(clean).replace(/"/g, "%22");
}
